<div class="m-0 mat-subtitle-1 d-flex flex-row align-items-center">
    <span> Ending in </span>
    <div class="d-flex mat-subtitle-1 last-four-digits m-0 ms-2">•••• {{ lastFourDigits }}</div>
</div>
